// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchFooterSections, addFooterSection, updateFooterSection } from "../../api/footerApi";

// Async thunks for footerSection operations

export const getFooterSections = createAsyncThunk(
  "footerSection/getFooterSections",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchFooterSections();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createFooterSection = createAsyncThunk(
  "footerSection/createFooterSection",
  async (newFooterSection: { title: string; description: string; is_active: boolean; image?: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addFooterSection(newFooterSection);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editFooterSection = createAsyncThunk(
  "footerSection/editFooterSection",
  async (
    { updatedFooterSection }: { updatedFooterSection: { title: string; description: string; is_active: boolean; image?: string } },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateFooterSection(updatedFooterSection);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// FooterSection Slice

const footerSectionSlice = createSlice({
  name: "footerSection",
  initialState: {
    footerSections: [] as any[],
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all footer sections
      .addCase(getFooterSections.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.footerSections = action.payload;
      })
      .addCase(getFooterSections.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create footer section
      .addCase(createFooterSection.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(state.footerSections)) {
          state.footerSections.push(action.payload);
          state.status = true;
          state.msg = "Footer section created successfully.";
        } else {
          console.log("footerSections not an array");
        }
      })
      .addCase(createFooterSection.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Edit footer section
      .addCase(editFooterSection.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.footerSections)) {
          const index = state.footerSections.findIndex((section) => section.id === id);
          if (index !== -1) {
            state.footerSections[index] = data;
          }
          state.status = true;
          state.msg = "Footer section updated successfully.";
        } else {
          console.log("footerSections not an array");
        }
      })
      .addCase(editFooterSection.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetStatus } = footerSectionSlice.actions;
export default footerSectionSlice.reducer;
